document.addEventListener("DOMContentLoaded", function() {
  let titleTextViewMore = document.querySelector(".title-text-view-more");
  let descriptionTextViewMoreP = document.querySelector(".description-text-view-more p");
  let sumaHeightTitleParrafo1 = titleTextViewMore?.offsetHeight + descriptionTextViewMoreP.offsetHeight;

  document.querySelectorAll(".description-text-view-more p em").forEach(function(element) {
    if (element.textContent.trim() === "Leer más") {
      element.classList.add("read-more");
    }
  });

  if (window.innerWidth <= 768) {
    document.querySelector(".text-view-more").style.height = "500px";
  } else if (window.innerWidth <= 1024) {
    document.querySelector(".text-view-more").style.height = "530px";
  }

  document.querySelector(".btn-view-more button")?.addEventListener("click", function() {
    let textViewMore = document.querySelector(".text-view-more");
    if (textViewMore.offsetHeight > 530) {
      if (textViewMore.offsetHeight >= 530) {
        textViewMore.style.height = "530px";
      } else if (textViewMore.offsetHeight >= 500) {
        textViewMore.style.height = "500px";
      } else {
        textViewMore.style.height = "470px";
      }
      this.textContent = "Ver más";
    } else {
      textViewMore.style.height = "auto";
      this.textContent = "Ver menos";
    }
  });

  document.querySelectorAll(".description-text-view-more p em").forEach(function(element) {
    element.addEventListener("click", function() {
      if (element.textContent.trim() === "Leer más") {
        element.style.display = "none";
        element.closest(".description-text-view-more").style.height = "auto !important";
      }
    });
  });
});